import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Typography,
  message,
} from 'antd';
import { useDispatch } from 'react-redux';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import 'views/Auth/index.scss';
import { postLogin } from 'api/usuarios/auth';
import { getEntidadLogotipoPublico } from 'api/estructuraOrganizacional/entidadLogotipoPublico';
import logoDefault from 'assets/logo-sigob.png';
import { setFavicon } from 'utils/favicon';

const { Title, Text } = Typography;

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [logotipoEntidad, setLogotipoEntidad] = useState(null);
  const [logotipoCargado, setLogotipoCargado] = useState(false);

  useEffect(() => {
    let mounted = true;
    const fetchLogotipo = async () => {
      const logotipo = await getEntidadLogotipoPublico();
      if (mounted) {
        setLogotipoEntidad(logotipo);
        setLogotipoCargado(true);
        // Sin logotipo configurado se conserva el icono de pestaña por defecto
        setFavicon(logotipo);
      }
    };
    fetchLogotipo();
    return () => { mounted = false; };
  }, []);

  const onFinish = async () => {
    setLoading(true);
    const values = form.getFieldsValue();
    const loggedIn = await postLogin(dispatch, values);
    if (loggedIn) {
      navigate('/');
    } else {
      message.warn('No se ha podido iniciar sesión');
    }
    setLoading(false);
  };

  const rules = { required: [{ required: true }] };

  return (
    <Row align="center" justify="end" className="container-login">
      <Col className="bgContainer" />
      <Col className="footer">
        <Title style={{ fontWeight: 'bold' }} level={2}>
          NÓMINAS
        </Title>
      </Col>
      <Col xs={24} sm={24} md={6} id="login-wrapper">
        <Spin tip="Cargando..." spinning={loading}>
          <Col md={24} sm={12} id="login-container">
            {logotipoCargado && (
              <Row style={{ marginBottom: 15 }} justify="center">
                <img src={logotipoEntidad || logoDefault} style={{ width: 150 }} alt="logo" />
              </Row>
            )}
            <br />
            <Title
              style={{
                fontWeight: 'bold',
                color: '#808080',
              }}
              level={2}
            >
              Bienvenido
            </Title>
            <br />
            <Form
              name="login-form"
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
            >
              <Form.Item
                name="email"
                rules={rules.required}
                label="Correo"
                hasFeedback
              >
                <Input prefix={<MailOutlined />} allowClear />
              </Form.Item>
              <Form.Item
                name="password"
                rules={rules.required}
                label="Contraseña"
                hasFeedback
              >
                <Input.Password prefix={<LockOutlined />} allowClear />
              </Form.Item>
              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  type="link"
                  className="auth"
                  style={{ width: '100%', textAlign: 'right' }}
                  onClick={() => navigate('/recuperar-contrasena')}
                >
                  ¿Olvidó su contraseña?
                </Button>
              </Form.Item>
              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  htmlType="submit"
                  shape="round"
                  className="auth-submit-button"
                  block
                >
                  Iniciar sesión
                </Button>
              </Form.Item>
            </Form>
          </Col>
          <Text className="version">
            Ver.
            {process.env.REACT_APP_VERSION}
          </Text>
        </Spin>
      </Col>
    </Row>
  );
};

export default Login;
